import { message } from 'antd';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { isOnMobile, sleep } from '../../lib/Utils';
import { allCollectionDataState } from '../../recoil/atoms';
import { storageService } from '../../lib/db/StorageService';

const useCollections = () => {
  const { t } = useTranslation();
  const [collectionList, setCollectionList] = useRecoilState(
    allCollectionDataState,
  );
  const [loading, setLoading] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(true);

  const [shouldShowLoadMoreButtonC, setShouldShowLoadMorebuttonC] = useState(
    !loading &&
      showLoadMore &&
      collectionList &&
      collectionList.collections &&
      collectionList.collections.length > 0,
  );

  const onLoadMoreCollections = async () => {
    setLoading(true);

    const nextFetchSize = isOnMobile() ? 6 : 8;
    const loadCollectionData = await storageService.findAllCollections(
      nextFetchSize,
    );
    const moreCollections = loadCollectionData.collections;

    if (
      collectionList.collections.length >= moreCollections.length &&
      moreCollections.length > 0
    ) {
      message.warning(t('You have loaded all items'));
      setLoading(false);
      setShowLoadMore(false);
      setShouldShowLoadMorebuttonC(false);
      return;
    }

    if (moreCollections.length > 0) {
      setCollectionList({
        ...collectionList,
        collections: moreCollections,
      });

      window.dispatchEvent(new Event('resize'));
    }

    await sleep(2_000);

    setLoading(false);
  };

  return {
    onLoadMoreCollections,
    shouldShowLoadMoreButtonC,
    setShouldShowLoadMorebuttonC,
  };
};

export default useCollections;
